import { Observable } from "rxjs"
import {
    ChromeTcpSocket
} from "./chrome-tcp-socket";

import {
    NodeTcpSocket,
    NodeTcpSocketServer
} from "./node-tcp-socket";

import {
    CordovaTcpSocketServer
} from "./cordova-tcp-socket";

export interface TilbyTcpSocketConnectOptions {
    timeout: number
}

export interface TilbyTcpSocket {
    get remoteAddress(): string | undefined
    get remotePort(): number | undefined

    onData: Observable<Uint8Array>
    onError: Observable<string>

    connect(ipAddress: string, port: number, options: TilbyTcpSocketConnectOptions): Promise<void>
    send(data: Uint8Array): Promise<void>
    disconnect(): Promise<void>
    close(): Promise<void>
}

export interface TilbyTcpSocketServer {
    onConnection: Observable<TilbyTcpSocket>

    listen(port: number): Promise<void>
    close(): Promise<void>
}

export class TilbyTcpSocketUtils {
    public static ab2Hex(ab: Uint8Array, byteSeparator: string = ' '): string {
        return Array.from(ab, (byte) => byte.toString(16).padStart(2, '0'))
            .join(byteSeparator);
    }

    public static byteArrayToString = (arr: Uint8Array): string => {
        const decoder = new TextDecoder();
        return decoder.decode(arr);
    }

    public static getSocket(): (TilbyTcpSocket | undefined) {
        if (window.require) {
            return new NodeTcpSocket();
        } else if (window.chrome?.sockets?.tcp) {
            return new ChromeTcpSocket();
        }

        // Return undefined if no suitable socket implementation is found
        return undefined; 
    }

    public static getSocketServer(): (TilbyTcpSocketServer | undefined) {
        if (window.require) {
            return new NodeTcpSocketServer();
        } else if (window.tilbyTCP) {
            return new CordovaTcpSocketServer();
        }

        // Return undefined if no suitable server implementation is found
        return undefined;
    }
}